import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';
import { SamplesModule } from '@app/samples/samples.module';
import { SamplesComponent } from '@app/samples/samples.component';

const apiUrl = 'https://api-activitycenter.portalstg2.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  modules: [
    SamplesModule
  ],
  production: false,
  routes: [
    {
      path: ':tenantId/activitycenter',
      component: SamplesComponent,
      children: [
        // Add Sample pages here. Use the code below as a guide.
        // { path: 'activitycenter-component', component: SamplePageComponent, data: { title: 'ACTIVITYCENTER Component' } },
      ]
    },
  ],
  version: buildVersion as BuildVersion,
};
